import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useSelector } from 'react-redux';
import IssueSummary from '@src/components/eco-alert-detail/IssueSummary';
import ImpactDetail from '@src/components/eco-alert-detail/ImpactDetail';
import Title from '@components/eco-alert-detail/Title';
// import OptionsPopover from '@src/components/summary-panel/SummaryContainer/Options';
// import OptionList from '@src/components/summary-panel/SummaryContainer/OptionList';
// import CascadeTrends from '@components/eco-alert-detail/Trends';
import ServicesGraph from '@components/eco-alert-detail/ServicesGraph';
import DashboardTabs from '@src/components/common/Dashboard/DashboardTabs';
import { getAlertDiagnosticsData } from '@api/eco2Alerts';
import localStorage from '@utils/localStorage';
import createKeyByUserName from '@src/utils/tempDashboard/createKeyByUserName';
import { prefix } from '@src/store/tempDashboard/types';
import { DASHBOARD_TYPE } from '@src/utils/constants';
import { humanize } from '@src/utils';
import ErrorBoundary from '@src/components/common/Retry/ErrorBoundary';
import { Wrapper, Header, Content, ActionPanel, SummaryPanel } from './styled';

import { selectedCustomerIdSelector, selectedUserNameSelector } from '@src/store/common/selectors';

export default function EcoAiAlertDetail(props) {
  const [diagnosticData, setDiagnosticData] = useState<any>({});
  const [rootCause, setRootCause] = useState('');
  // const [mergedFilters, setMergedFilters] = useState({} as any);

  const [loading, setLoading] = useState(true);
  const { id } = props.match.params;

  const customerId = useSelector(selectedCustomerIdSelector);
  const userName = useSelector(selectedUserNameSelector);

  const localStorageKey = createKeyByUserName(prefix, customerId, userName);
  const localStorageTempDashboards = localStorage.get(localStorageKey)?.dashboards || {};

  const alertId = localStorageTempDashboards[id]?.dashboard?.alertId || '';

  const getRootCauseNode = (metricScopes, rootCause) => {
    return Object.values(metricScopes)
      .map((scope: any) => scope.nodeMetricList)
      .flat()
      .find((node) => node.filterDisplayContent === rootCause);
  };

  const genRootCause = (data) => {
    try {
      const rootCauseNode = getRootCauseNode(
        data.metricScopes,
        data.alertSummary.rootCauseDisplayContent,
      );
      const rootCause = `${Object.entries(rootCauseNode.displayFilters).map(
        ([key, value]) => `${key} ${value}`,
      )} having a ${rootCauseNode.metrics
        .filter((metric) => metric.type === 'impacted')
        .map(
          (metric) =>
            `${metric.metricName} of ${humanize(metric.value, metric.unit)} ${metric.unit === 'ms' ? '' : metric.unit}`,
        )
        .join(' and ')}`;
      setRootCause(rootCause);
    } catch (e) {
      setRootCause('');
    }
  };

  useEffect(() => {
    const fetchDiagnosticData = async () => {
      const response = await getAlertDiagnosticsData({
        params: {
          alertId,
        },
      });
      return response.data;
    };

    fetchDiagnosticData()
      .then((data) => {
        setDiagnosticData(data);
        genRootCause(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        message.error('API Error');
      });
  }, []);

  if (!localStorageTempDashboards) {
    message.error('Local storage is empty');
  }

  if (
    localStorageTempDashboards[id]?.type !== DASHBOARD_TYPE.EXPERIENCE_ALERT_DIAGNOSTICS ||
    !alertId
  ) {
    message.error('Invalid alertId');
  }

  return (
    <ErrorBoundary>
      <Wrapper>
        <Header>
          <DashboardTabs id={id} />
        </Header>
        <Content>
          <ActionPanel>
            <Title
              content={`Experience Alert - ${diagnosticData?.alertSummary?.cohort}`}
              loading={loading}
            />
          </ActionPanel>

          <SummaryPanel>
            <IssueSummary
              loading={loading}
              metrics={diagnosticData.metricScopes}
              alertSummary={diagnosticData.alertSummary}
            />
            <ImpactDetail
              detail={diagnosticData.alertSummary}
              loading={loading}
              rootCause={rootCause}
            />
          </SummaryPanel>
          <ServicesGraph diagnosticData={diagnosticData} loading={loading} alertId={alertId} />
          {/* <CascadeTrends /> */}
        </Content>
      </Wrapper>
    </ErrorBoundary>
  );
}
